import React, { useState, useEffect } from 'react';
import SpinnerComponent from '../Player/Spinner';

export const FilePlayer = ({
  src,
  thumbnail,
  onPlay,
  onPause,
  onProgress,
  onDurationChange,
  onError,
  onEnded,
  handleFullscreen,
  refVideo,
  loading = false,
  playbackRate = 1.0,
  startSecond = 0,
}) => {
  const [videoError, setVideoError] = useState(null);

  const handleProgress = (e) => {
    const time = e.target.currentTime || 0;
    if (onProgress && time > 0) {
      onProgress(time || 0);
    }
  };

  useEffect(() => {
    if (playbackRate && refVideo.current && src) {
      refVideo.current.playbackRate = playbackRate;
      if (typeof refVideo.current.play === 'function') {
        refVideo.current.play();
      }
    }
  }, [playbackRate, src, refVideo]);

  useEffect(() => {
    const videoEl = refVideo.current;
    if (!videoEl || !src || !startSecond) return;

    const targetSecond = startSecond - 3 > 0 ? startSecond - 3 : 0;

    const doSeek = () => {
      videoEl.currentTime = targetSecond || 0;
    };

    if (videoEl.readyState >= 1) {
      doSeek();
    } else {
      videoEl.addEventListener('loadedmetadata', doSeek, { once: true });
      return () => videoEl.removeEventListener('loadedmetadata', doSeek);
    }
  }, [startSecond, src, refVideo]);

  return (
    <div className="file-player-wrapper">
      <video
        src={src}
        id="video-live-stream-file"
        onDoubleClick={() => handleFullscreen()}
        poster={thumbnail}
        ref={(p) => {
          refVideo.current = p;
        }}
        className="file-player"
        onDurationChange={(e) => {
          if (onDurationChange) onDurationChange(e.target.duration);
        }}
        onError={() => {
          setVideoError("Can't play this video");
          if (onPause) {
            onPause();
          }
          if (onError) {
            onError();
          }
        }}
        onEnded={onEnded}
        autoPlay
        onPlay={onPlay}
        onPause={onPause}
        onTimeUpdate={handleProgress}
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
        }}
      />
      {loading && (
        <div className="file-player-spinner">
          <SpinnerComponent />
        </div>
      )}
      {videoError && <div className="video-error">{videoError}</div>}
    </div>
  );
};
